module.exports = "https://cdn.realtymogul.com/static/media/icon_mobile.9b732353.svg";